export default "__VITE_ASSET__CG1fhPxw__"